
export class ConstantsApplication {
    static VERSION_ORIGIN = 'v2.1.48';
    static QUANTITY_LEFT_DAYS = 15;

    /** Impuesto de catálogo (`GET /tax` → `code`) requerido en líneas nuevas y permisos parciales en OC `received` para roles no admin/super. */
    static PO_RECEIVED_NON_ADMIN_ITEM_TAX_CODE = '15';

    // Colores de fondo de fila (usados tanto en frontend como en Excel)
    static BG_STOCK_MAXIMUM = '#8eb6f1';
    static BG_STOCK_MINIMUM = '#f0fa6a';
    static BG_LOW_ROTATION = '#deb5fa';

    // Colores de texto (formato RRGGBB para Excel)
    static FONT_COLOR_RED = 'FF0000';
    static FONT_COLOR_GREEN = '008000';

    /** Umbral en minutos para marcar duración venta→emisión como lenta (p-tag danger). */
    static SALE_INVOICE_DURATION_THRESHOLD_MINUTES = 30;
}